<ng-template let-item="item">
    <app-candidate-search-option-template-item [candidateSearchItem]="item"></app-candidate-search-option-template-item>
</ng-template>
